// ─── Guest identity ─────────────────────────────────────────────────
// A signed-out player used to fall through every fallback as "PLAYER" or
// "GUEST", and because the leaderboard aggregates by nickname, every guest
// on earth merged into one composite ghost (the 170k-point "PLAYER" on the
// all-time board is not a person, it is all of them).
//
// The fix other games converged on: mint a name once per device, keep it,
// let the player change it if they care. Kahoot, Fall Guys and Among Us all
// live in this family. Zero friction, stable identity.
//
// The vocabulary is WOT's own exploration language, one family with the
// Atlas rank names, so a minted name reads native: COMET-482, VOYAGER-217.
// Known limits, accepted: a new device mints a new name, and two devices
// minting the same name still merge on the board. The real cure is the
// account-identity work before public launch; this stops today's bleeding.

const GUEST_KEY = 'wot_guest_name';

const WORDS = [
  'COMET', 'NOVA', 'ORBIT', 'PIONEER', 'NOMAD', 'METEOR',
  'QUASAR', 'PULSAR', 'ROVER', 'FALCON', 'ZENITH', 'HORIZON',
  'AURORA', 'VECTOR', 'TITAN', 'ECLIPSE', 'BEACON', 'RAPTOR',
];

function mint(): string {
  const word = WORDS[Math.floor(Math.random() * WORDS.length)];
  const num = 100 + Math.floor(Math.random() * 900);
  return `${word}-${num}`;
}

/**
 * The device's guest name, minted on first ask and stable afterwards.
 * Signed-in players never see this: their Google name overwrites the store
 * nickname the moment auth resolves.
 */
export function getGuestName(): string {
  try {
    const existing = localStorage.getItem(GUEST_KEY);
    if (existing) return existing;
    const name = mint();
    localStorage.setItem(GUEST_KEY, name);
    return name;
  } catch {
    // Storage blocked (private mode): a session-stable name is still better
    // than PLAYER, so mint once and hold it in module scope.
    if (!sessionName) sessionName = mint();
    return sessionName;
  }
}

let sessionName: string | null = null;
